import { vars } from "@imwebme/clay-token";
import type { ElementType } from "react";
import { Typography } from "../Typography";
import type { TextfieldHelperTextProps } from "./Textfield.types";

export const TextfieldHelperText = <Element extends ElementType>({
  children,
  ...restProps
}: TextfieldHelperTextProps<Element>) => {
  return (
    <Typography
      variant="body-small"
      sx={{
        "[data-clay-textfield-container-size]:has(input[aria-invalid='true']) ~ &": {
          color: vars.semantic.color.textCritical,
        },

        "[data-clay-textfield-container-size]:has(input[aria-invalid='false']) ~ &": {
          color: vars.semantic.color.textSuccess,
        },
      }}
      {...restProps}
    >
      {children}
    </Typography>
  );
};
